<template>
  <Marco>
    <div slot="content">
      <div class="main-title">
        <h1 class="title">{{ step.pregunta }}</h1>
      </div>

      <div class="field-row">
        <div class="field">
          <p class="label">{{ step.subPregunta }}</p>

          <div class="wysiwyg">
            <div v-for="item in step.posiblesRespuestas" :key="item.id">
              <label for="chkAccesorios">
                <input
                  id="chkAccesorios"
                  v-model="item.checked"
                  :value="item.id"
                  type="checkbox"
                />
                {{ item.descr }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a slot="botonAtras" href="#" @click.prevent="$router.go(-1)">Atrás</a>
    <a slot="botonSiguiente" href="#" @click.prevent="siguiente()">
      Siguiente</a
    >
  </Marco>
</template>

<script>
export default {
  store: ["step"],

  data() {
    return {
      respuestas: []
    };
  },

  mounted() {
    console.log(this.step.posiblesRespuestas);
  },

  methods: {
    siguiente: async function() {
      this.step.posiblesRespuestas.forEach(element => {
        if (element.checked == true) {
          this.respuestas.push(element.id);
        }
      });

      console.log("Accesorios:" + this.respuestas);
      this.$emit("elegido", this.respuestas);
    }
  }
};
</script>

<style lang="scss" scoped></style>
